'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _Dropdown = require('./Dropdown.scss');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var caret = require('../../../res/images/common/dropdown_arrow_light_gray.svg');

var CustomDropdown = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CustomDropdown, _Component);

  function CustomDropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CustomDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomDropdown.__proto__ || (0, _getPrototypeOf2.default)(CustomDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.onMenuItemClick = function (newItem) {
      _this.props.onItemClick(newItem);
    }, _this.getText = function (item) {
      var text = '';
      if (item) {
        if (item.messageDescriptor) {
          var formatMessage = _this.props.intl.formatMessage;

          text = formatMessage(item.messageDescriptor);
        } else {
          text = item.text;
        }
      }
      return text;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CustomDropdown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectedItem = this.props.selectedItem;
      var className = _Dropdown2.default.langDropdown + ' ' + this.props.className;

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _reactBootstrap.Dropdown,
          { pullRight: true, id: 'dropdown-lang' },
          _react2.default.createElement(
            _reactBootstrap.Dropdown.Toggle,
            { noCaret: true },
            _react2.default.createElement(
              'div',
              { className: _Dropdown2.default.currentText },
              this.getText(selectedItem)
            ),
            _react2.default.createElement('img', { className: _Dropdown2.default.caret, src: caret })
          ),
          _react2.default.createElement(
            _reactBootstrap.Dropdown.Menu,
            { className: 'dropdown-menu' },
            this.props.items ? this.props.items.map(function (item) {
              return _react2.default.createElement(
                _reactBootstrap.MenuItem,
                { key: item.id, eventKey: item.id, onClick: function onClick() {
                    return _this2.onMenuItemClick(item);
                  }, className: item.id === selectedItem.id ? _Dropdown2.default.hidden : '' },
                _this2.getText(item)
              );
            }) : ''
          )
        )
      );
    }
  }]);
  return CustomDropdown;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  intl: _reactIntl.intlShape.isRequired,
  items: _react.PropTypes.array,
  onItemClick: _react.PropTypes.func.isRequired,
  selectedItem: _react.PropTypes.object
}, _temp2);
exports.default = (0, _reactIntl.injectIntl)(CustomDropdown);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropdown/Dropdown.js
// module id = 1950
// module chunks = 0